const mark = action => `login/${action}`;

export const LOGIN = mark("LOGIN");
export const LOGIN_SUCCESS = mark("LOGIN_SUCCESS");
export const LOGIN_FAILED = mark("LOGIN_FAILED");
export const login = data => ({
  type: LOGIN,
  payload: { data },
  meta: { thunk: true }
});
export const loginSuccess = (data, meta) => ({
  type: LOGIN_SUCCESS,
  payload: { data },
  meta
});

export const loginFailed = (error, meta) => ({
  type: LOGIN_FAILED,
  payload: { error },
  meta,
  error: true
});

export const AUTHENTICATE = mark("AUTHENTICATE");
export const AUTHENTICATE_SUCCESS = mark("AUTHENTICATE_SUCCESS");
export const AUTHENTICATE_FAILED = mark("AUTHENTICATE_FAILED");
export const authenticate = data => ({
  type: AUTHENTICATE,
  payload: { data },
  meta: { thunk: true }
});
export const authenticateSuccess = (data, meta) => ({
  type: AUTHENTICATE_SUCCESS,
  payload: { data },
  meta
});

export const authenticateFailed = (error, meta) => ({
  type: AUTHENTICATE_FAILED,
  payload: { error },
  meta,
  error: true
});

export const LOGOUT = mark("LOGOUT");

export const logout = data => ({
  type: LOGOUT,
  payload: { data },
  meta: { thunk: true }
});



// WEBPACK FOOTER //
// ./src/actions/login.js